import {HttpClient} from '@angular/common/http'
import {inject, Injectable} from '@angular/core'
import {BehaviorSubject, Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {environment} from '../../environments/environment'
import {User} from './types'

@Injectable({
  providedIn: 'root'
})
export class UserService {
  /**
   * Consumers should listen to this to get the latest user list.
   */
  public users$ = new BehaviorSubject<User[]>([])

  private httpClient = inject(HttpClient)

  public getUsers(update?: boolean): Observable<User[]> {
    let url = `${environment.userServiceUrl}/users`
    if (update === true) {
      url += `?bust=${new Date().getTime()}`
    }
    return this.httpClient.get<User[]>(url)
      .pipe(
        map((users: User[]) => {
          this.users$.next(users)
          return users
        })
      )
  }

  public getOffices(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${environment.userServiceUrl}/data/offices`)
  }

  public getUser(sId: string): User {
    return this.users$.value.find((user: User) => user.sId === sId) || {} as User
  }
}
